module.exports = __webpack_public_path__ + "static/feature-team-6448e5e233f421593c51afc2e9624f1b.png";